import { render } from "./Projects.vue?vue&type=template&id=90f5833e&scoped=true"
const script = {}

import "./Projects.vue?vue&type=style&index=0&id=90f5833e&scoped=true&lang=css"

import exportComponent from "/Users/dmitriykuptsov/workspace/front-end-development/strangebit.io/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f5833e"]])

export default __exports__